import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Star"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 4.89L14.07 9.075L14.415 9.825L15.165 9.9375L19.785 10.605L16.5 13.83L15.9375 14.3775L16.0725 15.1275L16.86 19.725L12.7275 17.5575L12 17.25L11.3025 17.6175L7.17001 19.755L7.92001 15.1575L8.05501 14.4075L7.50001 13.83L4.18501 10.5675L8.80501 9.89999L9.55501 9.78749L9.90001 9.0375L12 4.89ZM12 1.5L8.58746 8.415L0.959961 9.5175L6.47996 14.9025L5.17496 22.5L12 18.915L18.825 22.5L17.52 14.9025L23.04 9.525L15.4125 8.415L12 1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Star.vue"]]);
